export default __webpack_public_path__ + "static/calendar-1-9e71f6a8ca48b43d9ed6142875d776d6.svg";